import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './policy.css';

function PolicyLimits() {
  const navigate = useNavigate();
  const location = useLocation();
  const { employee } = location.state || { employee: null };
  
  const [activePolicy, setActivePolicy] = useState('engineers');
  const [policyStatus, setPolicyStatus] = useState(true);
  const [monthlyLimit, setMonthlyLimit] = useState('5,000');
  const [categoryLimits, setCategoryLimits] = useState({
    travel: { enabled: true, limit: '2,500', perDay: '', maxClaims: '' },
    food: { enabled: true, limit: '1,500', perDay: '', maxClaims: '' },
    fuel: { enabled: true, limit: '3,000', perDay: '', maxClaims: '' },
    other: { enabled: true, limit: '1,000', perDay: '', maxClaims: '' }
  });

  const policyGroups = [
    { id: 'all', name: 'All Employees', icon: 'users', count: 148, active: false },
    { id: 'executives', name: 'Executives', icon: 'user-tie', count: 12, active: false },
    { id: 'engineers', name: 'Engineers', icon: 'code', count: 85, active: true },
    { id: 'senior-engineers', name: 'Senior Engineers', icon: 'star', count: 28, active: false },
    { id: 'managers', name: 'Managers', icon: 'user-gear', count: 18, active: false },
    { id: 'senior-managers', name: 'Senior Managers', icon: 'crown', count: 5, active: false },
    { id: 'custom', name: 'Custom Policies', icon: 'sliders', count: 7, active: false },
    { id: 'branch', name: 'Branch Specific', icon: 'building', count: 3, active: false },
    { id: 'inactive', name: 'Inactive Rules', icon: 'ban', count: 2, active: false }
  ];

  const handleCategoryToggle = (category) => {
    setCategoryLimits(prev => ({
      ...prev,
      [category]: { ...prev[category], enabled: !prev[category].enabled }
    }));
  };

  const handleCategoryChange = (category, field, value) => {
    setCategoryLimits(prev => ({
      ...prev,
      [category]: { ...prev[category], [field]: value }
    }));
  };

  return (
    <div className="App">
      {/* Top Navbar */}
      

      {/* Payroll Sub-navigation */}
    

      {/* Employee Context Banner */}
      {employee && (
        <div className="employee-context-banner">
  <nav className="sub-nav">
        <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); navigate(-1); }}>
          ← Back
        </a>
     
      </nav>
          <div className="employee-context-content">
            <i className="fa-solid fa-user-circle"></i>
            <div>
              <strong>{employee.staffName || employee.employeeId}</strong> - Viewing Policy Limits
              <span className="employee-id">(ID: {employee.employeeId})</span>
            </div>
          </div>
        
        </div>
      )}

      {/* Main Content */}
      <main className="main-content">
        {/* Page Header */}
        <section className="page-header">
          <div>
            <h1 className="page-title">Reimbursement Policy Limits</h1>
            <p className="page-subtitle">Manage monthly caps, category limits, designation rules and exceptions.</p>
          </div>
          
          <div className="header-actions">
            <button className="btn-secondary">
              <i className="fa-solid fa-plus"></i> New Policy
            </button>
            <button className="btn-secondary">
              <i className="fa-solid fa-file-import"></i> Import Rules
            </button>
            <button className="btn-primary" >
              <i className="fa-solid fa-save"></i> Save Changes
            </button>
          </div>
        </section>

        {/* Main Layout */}
        <div className="layout-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="search-box">
              <i className="fa-solid fa-search"></i>
              <input type="text" placeholder="Search policies..." />
            </div>

            <div className="policy-groups">
              <h3 className="section-title">Policy Groups</h3>
              <div className="groups-list">
                {policyGroups.map(group => (
                  <button 
                    key={group.id}
                    className={`group-item ${group.active ? 'active' : ''}`}
                    onClick={() => setActivePolicy(group.id)}
                  >
                    <div className="group-info">
                      <i className={`fa-solid fa-${group.icon}`}></i>
                      <span>{group.name}</span>
                    </div>
                    <span className={`group-count ${group.active ? 'active' : ''}`}>{group.count}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Center Content */}
          <div className="center-content">
            {/* Policy Basic Info */}
            <div className="card1">
              <h3 className="card-title1">
                <i className="fa-solid fa-info-circle"></i>
                Policy Information
              </h3>
              
              <div className="form-grid">
                <div>
                  <label className="form-label">Policy Name</label>
                  <input type="text" value="Engineer Standard Policy" className="form-input" />
                </div>
                
                <div>
                  <label className="form-label">Applies To</label>
                  <select className="form-select">
                    <option>Designation = Engineer</option>
                    <option>Designation = Manager</option>
                    <option>Department = Engineering</option>
                  </select>
                </div>
                
                <div>
                  <label className="form-label">Branch</label>
                  <select className="form-select">
                    <option>All Branches</option>
                    <option>Bangalore</option>
                    <option>Mumbai</option>
                    <option>Delhi</option>
                  </select>
                </div>
                
                <div>
                  <label className="form-label">Effective From</label>
                  <input type="date" value="2026-04-01" className="form-input" />
                </div>
              </div>
              
              <div className="policy-status">
                <div>
                  <p className="status-title">Policy Status</p>
                  <p className="status-subtitle">Toggle to activate or deactivate this policy</p>
                </div>
                <label className="toggle-switch">
                  <input type="checkbox" checked={policyStatus} onChange={() => setPolicyStatus(!policyStatus)} />
                  <span className="toggle-slider"></span>
                </label>
              </div>
            </div>

            {/* Monthly Limits */}
            <div className="card">
              <h3 className="card-title1">
                <i className="fa-solid fa-calendar-days"></i>
                Overall Monthly Employee Cap
              </h3>
              
              <div className="monthly-limit">
                <label className="form-label">Monthly Limit</label>
                <div className="input-with-symbol">
                  <span className="symbol">₹</span>
                  <input 
                    type="text" 
                    value={monthlyLimit} 
                    onChange={(e) => setMonthlyLimit(e.target.value)}
                    className="form-input highlight" 
                  />
                  <span className="suffix">per month</span>
                </div>
              </div>
              
              <div className="checkbox-group">
                <label className="checkbox-label">
                  <input type="checkbox" />
                  <div>
                    <p className="checkbox-title">Carry forward unused balance</p>
                    <p className="checkbox-subtitle">Allow unused amount to roll over to next month</p>
                  </div>
                </label>
                
                <label className="checkbox-label">
                  <input type="checkbox" defaultChecked />
                  <div>
                    <p className="checkbox-title">Claim split across months</p>
                    <p className="checkbox-subtitle">Allow claims to be submitted across month boundaries</p>
                  </div>
                </label>
              </div>
            </div>

            {/* Category Limits */}
            <div className="card1">
              <h3 className="card-title1">
                <i className="fa-solid fa-layer-group"></i>
                Category Limits
              </h3>
              
              <div className="categories-grid">
                {Object.entries(categoryLimits).map(([category, data]) => (
                  <div key={category} className="category-card">
                    <div className="category-header">
                      <div className="category-icon">
                        <i className={`fa-solid fa-${category === 'travel' ? 'plane' : category === 'food' ? 'utensils' : category === 'fuel' ? 'gas-pump' : 'ellipsis'} ${category === 'travel' ? 'text-blue' : category === 'food' ? 'text-green' : category === 'fuel' ? 'text-amber' : 'text-purple'}`}></i>
                        <h4 className="category-name">{category.charAt(0).toUpperCase() + category.slice(1)}</h4>
                      </div>
                      <label className="toggle-switch small">
                        <input type="checkbox" checked={data.enabled} onChange={() => handleCategoryToggle(category)} />
                        <span className="toggle-slider"></span>
                      </label>
                    </div>
                    
                    <div className="category-fields">
                      <div>
                        <label className="field-label">Monthly Limit</label>
                        <div className="input-with-symbol small">
                          <span className="symbol">₹</span>
                          <input 
                            type="text" 
                            value={data.limit} 
                            onChange={(e) => handleCategoryChange(category, 'limit', e.target.value)}
                            className="category-input" 
                          />
                        </div>
                      </div>
                      
                      <div>
                        <label className="field-label">Per Day Cap (Optional)</label>
                        <input 
                          type="text" 
                          placeholder="No limit" 
                          value={data.perDay}
                          onChange={(e) => handleCategoryChange(category, 'perDay', e.target.value)}
                          className="category-input" 
                        />
                      </div>
                      
                      <div>
                        <label className="field-label">Max Claims/Month</label>
                        <input 
                          type="text" 
                          placeholder="Unlimited" 
                          value={data.maxClaims}
                          onChange={(e) => handleCategoryChange(category, 'maxClaims', e.target.value)}
                          className="category-input" 
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Approval Rules */}
            <div className="card1">
              <h3 className="card-title1">
                <i className="fa-solid fa-shield-halved"></i>
                Approval Rules
              </h3>
              
              <div className="approval-rules">
                <div>
                  <label className="form-label">Manager Approval Threshold</label>
                  <select className="form-select">
                    <option>Required above ₹2,000</option>
                    <option>Required above ₹1,000</option>
                    <option>Required above ₹5,000</option>
                    <option>Always required</option>
                  </select>
                </div>
                
                <div>
                  <label className="form-label">Finance Approval Threshold</label>
                  <select className="form-select">
                    <option>Required above ₹5,000</option>
                    <option>Required above ₹3,000</option>
                    <option>Required above ₹10,000</option>
                    <option>Always required</option>
                  </select>
                </div>
              </div>
              
              <div className="checkbox-group">
                <label className="checkbox-label">
                  <input type="checkbox" defaultChecked />
                  <div>
                    <p className="checkbox-title">Receipt mandatory above ₹500</p>
                    <p className="checkbox-subtitle">Require attachment for claims exceeding threshold</p>
                  </div>
                </label>
                
                <label className="checkbox-label">
                  <input type="checkbox" defaultChecked />
                  <div>
                    <p className="checkbox-title">GPS / Trip note mandatory for travel</p>
                    <p className="checkbox-subtitle">Require location or trip details for travel claims</p>
                  </div>
                </label>
                
                <label className="checkbox-label">
                  <input type="checkbox" defaultChecked />
                  <div>
                    <p className="checkbox-title">Duplicate bill detection ON</p>
                    <p className="checkbox-subtitle">Auto-flag potential duplicate submissions</p>
                  </div>
                </label>
              </div>
            </div>

            {/* Exception Rules */}
            <div className="card">
              <h3 className="card-title1">
                <i className="fa-solid fa-triangle-exclamation"></i>
                Exception Rules
              </h3>
              
              <div className="exception-tags">
                <span className="exception-tag purple">
                  Night Shift Meal Allowance
                  <button className="remove-tag"><i className="fa-solid fa-xmark"></i></button>
                </span>
                <span className="exception-tag blue">
                  Client Visit Override
                  <button className="remove-tag"><i className="fa-solid fa-xmark"></i></button>
                </span>
                <span className="exception-tag amber">
                  Emergency Fuel Override
                  <button className="remove-tag"><i className="fa-solid fa-xmark"></i></button>
                </span>
                <span className="exception-tag red">
                  Special Approval Only
                  <button className="remove-tag"><i className="fa-solid fa-xmark"></i></button>
                </span>
              </div>
              
              <button className="add-exception">
                <i className="fa-solid fa-plus"></i> Add Exception
              </button>
            </div>
          </div>

          {/* Right Insights */}
          <div className="right-sidebar">
            {/* Policy Preview */}
            <div className="insight-card">
              <h3 className="insight-title">
                <i className="fa-solid fa-eye"></i>
                Policy Preview
              </h3>
              
              <div className="preview-content">
                <div className="preview-item">
                  <p className="preview-label">Employee Type</p>
                  <p className="preview-value">Engineer</p>
                </div>
                
                <div className="preview-item highlight">
                  <p className="preview-label">Monthly Max</p>
                  <p className="preview-value large">₹{monthlyLimit}</p>
                </div>
                
                <div className="preview-stats">
                  <div>
                    <p className="stat-label">Travel</p>
                    <p className="stat-value">₹{categoryLimits.travel.limit}</p>
                  </div>
                  <div>
                    <p className="stat-label">Food</p>
                    <p className="stat-value">₹{categoryLimits.food.limit}</p>
                  </div>
                  <div>
                    <p className="stat-label">Fuel</p>
                    <p className="stat-value">₹{categoryLimits.fuel.limit}</p>
                  </div>
                  <div>
                    <p className="stat-label">Other</p>
                    <p className="stat-value">₹{categoryLimits.other.limit}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Impact Analysis */}
            <div className="insight-card">
              <h3 className="insight-title">
                <i className="fa-solid fa-chart-line"></i>
                Impact Analysis
              </h3>
              
              <div className="impact-content">
                <div className="impact-stat">
                  <p className="impact-label">Employees Affected</p>
                  <p className="impact-number">148</p>
                </div>
                
                <div className="impact-stat highlight">
                  <p className="impact-label">Est. Monthly Exposure</p>
                  <p className="impact-number purple">₹7,40,000</p>
                </div>
                
                <div className="impact-comparison">
                  <div className="comparison-row">
                    <span>Previous Limit</span>
                    <span>₹4,000</span>
                  </div>
                  <div className="comparison-row">
                    <span>Increase</span>
                    <span className="text-green">+₹1,000</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Conflict Alerts */}
            <div className="insight-card">
              <h3 className="insight-title">
                <i className="fa-solid fa-bell"></i>
                Policy Alerts
              </h3>
              
              <div className="alerts-list">
                <div className="alert-item">
                  <i className="fa-solid fa-triangle-exclamation"></i>
                  <div>
                    <p className="alert-title">Multiple Policies</p>
                    <p className="alert-desc">7 employees under multiple policies</p>
                  </div>
                </div>
                
                <div className="alert-item">
                  <i className="fa-solid fa-building"></i>
                  <div>
                    <p className="alert-title">Inactive Branches</p>
                    <p className="alert-desc">2 inactive branches mapped</p>
                  </div>
                </div>
                
                <div className="alert-item">
                  <i className="fa-solid fa-layer-group"></i>
                  <div>
                    <p className="alert-title">Overlapping Rules</p>
                    <p className="alert-desc">3 overlapping exceptions</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Actions */}
            <div className="insight-card">
              <h3 className="insight-title">Quick Actions</h3>
              
              <div className="quick-actions">
                <button className="action-btn">
                  <i className="fa-solid fa-clone"></i> Clone Policy
                </button>
                <button className="action-btn">
                  <i className="fa-solid fa-user-plus"></i> Assign Employees
                </button>
                <button className="action-btn">
                  <i className="fa-solid fa-power-off"></i> Deactivate
                </button>
                <button className="action-btn">
                  <i className="fa-solid fa-download"></i> Download Rules
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Policy History */}
        <section className="history-section">
          <h3 className="history-title">
            <i className="fa-solid fa-clock-rotate-left"></i>
            Policy History
          </h3>
          
          <div className="history-table">
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Action</th>
                  <th>User</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Apr 16, 2026</td>
                  <td>Updated Travel cap ₹2,000 → ₹2,500</td>
                  <td>Admin User</td>
                </tr>
                <tr>
                  <td>Apr 02, 2026</td>
                  <td>Added Fuel category</td>
                  <td>Finance Team</td>
                </tr>
                <tr>
                  <td>Mar 28, 2026</td>
                  <td>Created policy</td>
                  <td>HR Admin</td>
                </tr>
                <tr>
                  <td>Mar 15, 2026</td>
                  <td>Updated monthly cap ₹4,000 → ₹5,000</td>
                  <td>Admin User</td>
                </tr>
                <tr>
                  <td>Mar 01, 2026</td>
                  <td>Enabled duplicate detection</td>
                  <td>Finance Team</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </main>
    </div>
  );
}

export default PolicyLimits;